import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';

// Setup Redux
import { Provider } from 'react-redux';
import { store } from './redux';

// ErrorTracker is implicitly initialised by importing
import ErrorTracker from './services/ErrorTracker';

let appInited = false;
const bootApp = () => {
	ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
	unregister();
    appInited = true;
};

if (!appInited) bootApp();
